export const unloadedFile = "Wczytaj plik:";
export const unloadedNewFile = "Wczytaj nowy plik:";
export const emptyString = "-";
export const insuranceToDate="Do:";
export const expectedFileInsurance="Wymagany format to .pdf";
